const button = document.querySelector('.js-basket');
const element = document.querySelector('.js-basket-items');
if (element) {
	let id = element.id;
}

let isOpen = false;

export function init() {
	if (element) {
		button.addEventListener('click', function toggle() {
			isOpen ? close() : open();
		});
	}
}

function open() {
	isOpen = !isOpen;
	element.classList.add('is-active', isOpen);
	button.setAttribute('aria-expanded', 'true');
	button.setAttribute('aria-controls', `${id}`);
	reveal();
}

function close() {
	isOpen = !isOpen;
	element.classList.remove('is-active', isOpen);
	button.setAttribute('aria-expanded', 'false');
	button.setAttribute('aria-controls', `${id}`);
	reveal();
}

function reveal() {
	if (isOpen) {
		button.innerText = 'Hide';
	} else {
		button.innerText = 'View';
	}
}
